import React, { Component } from "react";
import { BounceLoader } from "react-spinners";
import ImageTools from "./ImageTools";

class ImageUpload extends Component {
	state = {
		file: "",
		imagePreviewUrl: ""
	};
	constructor(props) {
		super(props);
		this.state = {
			loading: false
		};
	}

	_handleImageChange = e => {
		this.setState({ loading: true });

		e.preventDefault();
		let reader = new FileReader();
		let file = e.target.files[0];

		ImageTools.resize(
			e.target.files[0],
			{
				width: 800, // maximum width
				height: 800 // maximum height
			},
			(blob, didItResize) => {
				var res = URL.createObjectURL(blob);
				this.setState({
					file: res,
					imagePreviewUrl: res
				});
				reader.readAsDataURL(file);

				this.setState({ loading: false });
				this.props.fieldValues.image = new File([blob], file.name);

				// didItResize will be true if it managed to resize it, otherwise false (and will return the original file as 'blob')

				// you can also now upload this blob using an XHR.
			}
		);
		/*
    if (file.size / 1024 / 1024 < 2) {
      reader.onloadend = () => {
        this.setState({ file: file, imagePreviewUrl: reader.result });
        this.setState({ loading: false });
      };
      reader.readAsDataURL(file);
      this.props.fieldValues.image = file;
    } else {
      alert("El archivo no puede superar los 2MB");
      this.setState({ loading: false });
    }*/
	};

	onPreview = e => {
		e.preventDefault();
		console.log("Preview");
		if (this.state.imagePreview === null) this.setState({ imagePreview: true });
		else {
			const s = !this.state.imagePreview;
			this.setState({ imagePreview: s });
		}
	};

	componentDidMount() {
		var inputs = document.querySelectorAll(".inputfile");
		Array.prototype.forEach.call(inputs, function(input) {
			var label = input.nextElementSibling,
				labelVal = label.innerHTML;

			input.addEventListener("change", function(e) {
				var fileName = "";
				if (this.files && this.files.length > 1)
					fileName = (this.getAttribute("data-multiple-caption") || "").replace(
						"{count}",
						this.files.length
					);
				else fileName = e.target.value.split("\\").pop();

				if (fileName) label.innerHTML = fileName;
				else label.innerHTML = labelVal;
			});
		});
	}

	render() {
		let { imagePreviewUrl } = this.state;
		const centerDiv = {
			margin: "0 auto"
		};

		let image;
		if (this.state.imagePreviewUrl !== "") {
			image = (
				<img
					alt={imagePreviewUrl}
					src={imagePreviewUrl}
					style={{ width: "auto", height: "200px" }}
				/>
			);
		} else {
			image = null;
		}

		return (
			<div style={centerDiv}>
				<div className="sweet-loading loading">
					<BounceLoader color={"#545454"} loading={this.state.loading} />
				</div>
				<input
					type="file"
					className="inputfile"
					name="file"
					id="file"
					accept="image/*"
					onChange={this._handleImageChange}
				/>
				{/* {this.state.imagePreviewUrl !== ""  ? (
          <img alt={imagePreviewUrl} src={imagePreviewUrl} style={{ width: '400px', height: "auto" }} />
        ) : null} */}
				{image}
			</div>
		);
	}
}

export default ImageUpload;
